import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { type PrefetchUrlConfig, getPrefetchUrls } from '../../utils/performance-utils';

const urlsToPrefetch: PrefetchUrlConfig[] = [
    { hostname: 'assets.surlatable.com', addCrossOrigin: false },
    { hostname: 'img.youtube.com', addCrossOrigin: false },
    { hostname: 'api.helloextend.com', addCrossOrigin: false },
    { hostname: 'sdk.helloextend.com', addCrossOrigin: false },
    { hostname: 'js.afterpay.com', addCrossOrigin: false },
];

export const PDPHead: FC = () => (
    <Helmet>
        {/* @ts-expect-error: __PRODUCTION__ variable will be replaced by webpack */}
        {__PRODUCTION__ ? getPrefetchUrls(urlsToPrefetch) : null}
    </Helmet>
);
